import { User } from '@/models/user'
import { BaseAPI } from '@/api/base.api'
import { BACK_URL_SERVICE } from '@/commons/config'
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface'

export class UserAPI extends BaseAPI<User> {
  constructor() {
    super()
    this.apiUrl = `${this.apiUrl}/api_app/v1`
  }

  public signin(cnpj: string, token: string, concordo: boolean): AxiosObservable<User> {
    return this.axios.post(`${this.apiUrl}/auth/login`, { cnpj, token, concordo })
  }
}
